import vehicleCheckService, { VehicleCheckData } from "@/lib/services/vehicle-check";
import { useEffect, useState } from "react";

export function useVehicleCheck(registration: string) {
    const [vehicleCheckData, setVehicleCheckData] =
        useState<VehicleCheckData | null>(null);
    const [checkingVehicle, setCheckingVehicle] = useState(false);
    const [vehicleCheckError, setVehicleCheckError] = useState<string | null>(
        null
    );
    const [vehicleCategory, setVehicleCategory] = useState<"under_3.5t" | "3.5-7.5t" | "over_7.5t" | undefined>(undefined);
    const [vehicleBodyType, setVehicleBodyType] = useState<string | undefined>(undefined);

    useEffect(() => {
        const checkVehicle = async () => {
            const reg = registration.trim().toUpperCase();

            // Only check if registration is at least 7 characters
            if (reg.length < 7) {
                setVehicleCheckData(null);
                setVehicleCheckError(null);
                setVehicleCategory(undefined);
                setVehicleBodyType(undefined);
                return;
            }

            setCheckingVehicle(true);
            setVehicleCheckError(null);

            try {
                const result = await vehicleCheckService.checkVehicle(reg);

                if (result.success && result.data) {
                    setVehicleCheckData(result.data);
                    setVehicleBodyType(result.data?.body_type as any);
                    setVehicleCategory(result.data?.vehicle_category as any);
                    setVehicleCheckError(null);
                } else {
                    setVehicleCheckData(null);
                    setVehicleCheckError(
                        result.message || "Unable to verify vehicle registration"
                    );
                    setVehicleCategory(undefined);
                    setVehicleBodyType(undefined);
                }
            } catch (error: any) {
                console.error("Vehicle check error:", error);
                setVehicleCheckData(null);
                setVehicleCheckError("Failed to check vehicle. Please try again.");
                setVehicleCategory(undefined);
                setVehicleBodyType(undefined);
            } finally {
                setCheckingVehicle(false);
            }
        };

        // Debounce the API call by 800ms
        const timeoutId = setTimeout(() => {
            checkVehicle();
        }, 800);

        return () => clearTimeout(timeoutId);
    }, [registration]);

    return {
        vehicleCheckData,
        checkingVehicle,
        vehicleCheckError,
        vehicleCategory,
        vehicleBodyType,
        setVehicleCategory,
        setVehicleBodyType,
    };
}
